import { render, staticRenderFns } from "./SimulationGrid.vue?vue&type=template&id=484d7380&"
import script from "./SimulationGrid.vue?vue&type=script&lang=js&"
export * from "./SimulationGrid.vue?vue&type=script&lang=js&"
import style0 from "./SimulationGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports